import { DatabasesExternalAssetsDisplayGridRowData } from '@tableau/catalog-ui-temp';
import { Action } from 'redux';

import { UngroupDatabases } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExplorableItemTypeInfo } from '../../../spacesPlatform/models/resourceInfoParts';

export type DatabaseForUngrouping =
  IExplorableItemTypeInfo<'database'> &
  Pick<DatabasesExternalAssetsDisplayGridRowData, 'name' | 'luid' | 'isGrouped'>;

export interface UngroupDatabasesAction extends Action {
  readonly database: DatabaseForUngrouping;
}

export function ungroupDatabasesAction(database: DatabaseForUngrouping): UngroupDatabasesAction {
  return {
    type: UngroupDatabases,
    database
  };
}
